import { render } from "./addRoleView.vue?vue&type=template&id=9f43e6d0&scoped=true&ts=true"
import script from "./addRoleView.vue?vue&type=script&lang=ts"
export * from "./addRoleView.vue?vue&type=script&lang=ts"

import "./addRoleView.vue?vue&type=style&index=0&id=9f43e6d0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f43e6d0"]])

export default __exports__